import React, { useState, useEffect } from 'react';
import { FaBell } from 'react-icons/fa';
import useAuthStore from '../../../store/authStore';
import { Button, Spin } from 'antd';
import useStateStore from '../../../store/stateStore';
import { Link, useNavigate } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import { format } from 'timeago.js'


const NotificationDropdown = () => {
    // const [notifications, setNotifications] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    // const [unreadCount, setUnreadCount] = useState(0);
    // const [loading, setLoading] = useState(false);

    const { notificationDetails,
        notificationCount,
        markAsReadNotifications,
        markAllAsReadNotifications,
        fetchLoading,
        markAsReadLoading,
        markAllAsReadLoading,
    } = useStateStore();
    const navigate = useNavigate();


    // console.log(notificationDetails, 'notificationDetails');
    // console.log(notificationCount, 'notificationCount');

    const { user } = useAuthStore();
    const userId = user._id

    // Mock fetch notifications
    // useEffect(() => {
    //     const fetchNotifications = async () => {
    //         // Replace with API call
    //         const page = 1
    //         const limit = 10
    //         const { data } = await getNotifications(page, limit)
    //         console.log(data);

    //         setNotifications(data.notifications);
    //         // setUnreadCount(mockNotifications.filter((n) => !n.isRead).length);
    //         setUnreadCount(
    //             data.notifications.filter(notification =>
    //                 notification.reciversId.some(
    //                     receiver => receiver.reciverId === userId && !receiver.isRead
    //                 )
    //             ).length
    //         );
    //     };
    //     fetchNotifications();
    // }, []);

    // useEffect(() => {
    //     setNotifications(notificationDetails)
    //     setUnreadCount(notificationCount)
    // }, [notificationDetails, notificationCount])

    // Toggle dropdown visibility
    const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

    // // Mark notification as read
    // const markAsRead = (id) => {
    //     setNotifications((prevNotifications) =>
    //         prevNotifications.map((n) =>
    //             n.id === id ? { ...n, isRead: true } : n
    //         )
    //     );
    //     setUnreadCount((count) => count - 1);
    // };

    // Mark notification as read
    const markAsRead = async (notificationId) => {

        // try {
        //     const { data } = await markNotificationAsRead(notificationId)
        //     console.log(data);

        //     if (data.success) {
        //         setNotifications((prevNotifications) =>
        //             prevNotifications.map((notification) => {
        //                 if (notification._id === notificationId) {
        //                     const updatedReciversId = notification.reciversId.map((receiver) =>
        //                         receiver.reciverId === userId ? { ...receiver, isRead: true, readAt: new Date() } : receiver
        //                     );
        //                     return { ...notification, reciversId: updatedReciversId };
        //                 }
        //                 return notification;
        //             })
        //         );
        //         setUnreadCount((count) => count - 1);

        //     //  await   setStateDetails(notifications, unreadCount)
        //     }

        // } catch (error) {
        //     console.error("Error marking notification as read:", error);
        // }

        await markAsReadNotifications(notificationId, userId)
    };

    const markAllAsRead = async () => {
        // try {
        //     setLoading(true)
        //     // Call backend API to mark all notifications as read
        //     const { data } = await markAllNotificationsAsRead()
        //     console.log(data);

        //     if (data.success) {
        //         // Update UI state to mark all as read
        //         setNotifications((prevNotifications) =>
        //             prevNotifications.map((notification) => {
        //                 const updatedReciversId = notification.reciversId.map((receiver) =>
        //                     receiver.reciverId === userId ? { ...receiver, isRead: true, readAt: new Date() } : receiver
        //                 );
        //                 return { ...notification, reciversId: updatedReciversId };
        //             })
        //         );
        //         setLoading(false)
        //         setUnreadCount(0);
        //  await   setStateDetails(notifications, unreadCount)
        //     }
        // } catch (error) {
        //     console.error("Error marking all notifications as read:", error);
        // }

        await markAllAsReadNotifications(userId)
    };

    const handleViewAll = () => {
        navigate("/notifications")
    }

    return (
        <div className="relative">
            {/* Bell Icon with Count */}
            <div
                onClick={toggleDropdown}
                className="w-8 h-8 bg-[#EAEFFF] border border-[#9FACF0] flex justify-center items-center rounded-full cursor-pointer relative"
            >
                <FaBell className="text-[#1955EB]" />
                {notificationCount > 0 && (
                    <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs w-4 h-4 flex justify-center items-center rounded-full">
                        {notificationCount}
                    </span>
                )}
            </div>

            {/* Notification Dropdown */}
            {isDropdownOpen && (
                <div className="absolute right-0 mt-3 w-[320px] md:w-[380px] bg-white border border-gray-100 rounded-2xl shadow-2xl z-[1000] overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
                    {/* Arrow */}
                    <div className="absolute top-0 right-3 -mt-1.5 w-3 h-3 bg-white border-t border-l border-gray-100 rotate-45 transform"></div>

                    <div className="relative bg-white">
                        <div className="p-4 border-b border-gray-50 flex justify-between items-center bg-white">
                            <h3 className="font-bold text-gray-800 text-[16px]">Notifications</h3>
                            {notificationCount > 0 && (
                                <button
                                    disabled={markAllAsReadLoading}
                                    className="text-xs font-bold text-[#1955EB] hover:text-blue-700 hover:underline disabled:text-gray-400 transition-all flex items-center gap-1"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        markAllAsRead();
                                    }}
                                >
                                    {markAllAsReadLoading ? <Spin indicator={<LoadingOutlined style={{ fontSize: 12 }} spin />} /> : null}
                                    Mark all as read
                                </button>
                            )}
                        </div>

                        <Spin spinning={fetchLoading} indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}>
                            <div className="max-h-[400px] overflow-y-auto scrollbar-hide">
                                {notificationDetails?.length === 0 ? (
                                    <div className="flex flex-col items-center justify-center py-10 px-4 text-center">
                                        <div className="w-12 h-12 bg-gray-50 rounded-full flex justify-center items-center mb-3">
                                            <FaBell className="text-gray-300 text-xl" />
                                        </div>
                                        <p className="text-gray-500 text-sm font-medium">No new notifications</p>
                                    </div>
                                ) : (
                                    <div className="divide-y divide-gray-50">
                                        {notificationDetails?.map((notification) => {
                                            const isUnread = notification?.reciversId?.some(
                                                (receiver) => receiver.reciverId === userId && !receiver.isRead
                                            );

                                            return (
                                                <div
                                                    key={notification._id}
                                                    className={`p-4 transition-colors relative flex gap-3 ${isUnread ? 'bg-blue-50/30 hover:bg-blue-50' : 'bg-white hover:bg-gray-50'}`}
                                                    onClick={() => {
                                                        if (isUnread) markAsRead(notification._id);
                                                    }}
                                                >
                                                    {isUnread && (
                                                        <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#1955EB]"></div>
                                                    )}

                                                    <div className="flex-1 min-w-0 text-start">
                                                        <div className="flex justify-between items-start gap-2 mb-1">
                                                            <p className={`text-sm leading-tight truncate ${isUnread ? 'font-bold text-gray-900' : 'font-medium text-gray-600'}`}>
                                                                {notification.title}
                                                            </p>
                                                            <span className="text-[10px] text-gray-400 whitespace-nowrap font-medium">
                                                                {format(notification.createdAt)}
                                                            </span>
                                                        </div>
                                                        <p className="text-[12px] text-gray-500 leading-relaxed line-clamp-2">
                                                            {notification.body} {notification?.senderId?.name}. Check it out now!
                                                        </p>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </Spin>

                        <Link
                            to="/notifications"
                            className="block p-3.5 border-t border-gray-50 text-center text-[13px] font-bold text-[#1955EB] hover:bg-blue-50 transition-colors bg-white rounded-b-2xl"
                            onClick={() => setIsDropdownOpen(false)}
                        >
                            View All Notifications
                        </Link>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NotificationDropdown;
